import { Link } from "react-router-dom";

const Yoga = () => {
  return (
    <div className="min-h-screen px-4 py-12 bg-gradient-to-br from-green-100 via-blue-50 to-purple-100 dark:from-gray-900 dark:via-gray-800 dark:to-gray-900 transition duration-300">
      <div className="max-w-6xl mx-auto bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden flex flex-col md:flex-row items-center">

        {/* Image Section */}
        <div className="md:w-1/2 flex justify-center items-center p-4">
          <img
            src="https://images.unsplash.com/photo-1566501206188-5dd0cf160a0e?w=600&auto=format&fit=crop&q=60&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MzZ8fHlvZ2F8ZW58MHx8MHx8fDA%3D"
            alt="Yoga Woman"
            className="w-full max-w-md h-auto rounded-lg object-cover object-center shadow-lg"
          />
        </div>

        {/* Content Section */}
        <div className="md:w-1/2 p-6 md:p-10 flex flex-col justify-center">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800 dark:text-white mb-4">
            🧘‍♀️ Yoga Teacher
          </h1>
          <p className="text-lg text-gray-700 dark:text-gray-300 mb-6 leading-relaxed">
            Yoga balances the body and mind. Our expert yoga programs are designed to nurture flexibility, focus, and inner peace—especially for children and working professionals.
          </p>

          <div className="bg-gray-50 dark:bg-gray-700 rounded-xl p-4 md:p-6 shadow-inner mb-6">
            <h2 className="text-2xl font-bold text-gray-800 dark:text-white mb-3">🌟 What We Offer:</h2>
            <ul className="list-disc list-inside space-y-3 text-gray-700 dark:text-gray-200 text-base">
              <li>🧒 Fun and safe yoga postures for kids and teens</li>
              <li>🌬️ Guided breathing and mindfulness sessions</li>
              <li>👨‍👩‍👧 Parent-child interactive yoga programs</li>
              <li>🏢 On-site yoga teachers for your office or workplace</li>
              <li>🏡 Personal home training sessions available</li>
              <li>🏥 Specialized programs for senior citizens and beginners</li>
              <li>🧘‍♂️ Male & Female yoga instructors to suit your comfort</li>
              <li>🏛️ Dedicated Yoga Practice Center with peaceful ambiance</li>
              <li>📅 Flexible scheduling for morning & evening batches</li>
            </ul>
          </div>

          <div className="w-full flex flex-col sm:flex-row items-center justify-center gap-4 mt-6">
            <Link to="/contact">
              <button className="bg-pink-600 hover:bg-pink-700 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto">
                Book a Free Trial Class
              </button>
            </Link>
            <a
              href="https://wa.me/919999999999"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white text-sm font-medium px-6 py-3 rounded-md shadow transition duration-300 w-64 sm:w-auto text-center"
            >
              📲 Connect on WhatsApp
            </a>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Yoga;
